<template>
    <div v-if="show" class="modal-wrapper">
        <form class="modal" @submit.prevent="nextStep()">
            <h3>Add to Funnel</h3>
            <div class="modal-content">
                <div v-if="step === 0" class="field">
                    <label>Which funnel should {{app.selected.length === 1 ? app.selected[0].name : 'these ' + app.selected.length + ' people'}} start?</label>
                    <select v-model="selectedFunnel">
                        <option v-for="funnel in app.funnels" :key="funnel.id" :value="funnel">
                            {{funnel.name}}
                        </option>
                    </select>
                </div>

                <div v-if="step === 1" class="field">
                    <p>Adding {{app.selected.length}} people to {{selectedFunnel.name}}... don't close this window.</p>
                    <p>{{currentImport}} / {{totalImport}} People</p>
                </div>
            </div>
            <div class="modal-actions">
                <a @click="show = false" href="javascript:;" class="cancel">Cancel</a>
                <button v-if="step === 0">
                    <span >Add to Funnel</span>
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import async from 'no-async';

export default {
    props: ['app'],
    data() {
        return {
            selectedFunnel: undefined,
            show: false,
            step: 0,
            currentImport: 0,
            totalImport: 0
        };
    },
    watch: {
        show(val) {
            var _ = this;

            if (val) {
                _.selectedFunnel = _.app.funnels[0];
            }
        }
    },
    methods: {
        nextStep() {
            var _ = this;

            _.step++;

            if (_.step === 1) {
                _.addToCampaign();
            } else if (_.step === 2) {
                _.step = 0;
                _.selectedFunnel = _.app.funnels[0];
                _.app.selected = [];
                _.show = false;
            }
        },

        addToCampaign() {
            var _ = this,
                people = _.app.selected,
                chunkSize = 50,
                maxChunks = Math.ceil(people.length / chunkSize),
                chunks = [],
                now = Date.now();

            _.totalImport = people.length;

            for (var i = 0; i < maxChunks; i++) {
                chunks.push(i * chunkSize);
            }

            async.eachSeries(chunks, function(startIndex, next) {
                _.currentImport = startIndex + 1;

                _.app.requester.request({
                    controller: 'events',
                    action: 'save',
                    events: people.slice(startIndex, startIndex + chunkSize).map(function(person) {
                        return {
                            funnelId: _.selectedFunnel.id,
                            personId: person.id,
                            status: 'pending',
                            post_date: now,
                            funnelStartAt: now,
                            updatedAt: now
                        };
                    })
                }, function() {
                    next();
                });
            }, function() {
                _.nextStep();
            });
        }
    }
};
</script>
